import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { createCtx } from '@pletly/ui';

import {
	OrganisationInfo,
	OrganisationTeamRole,
	OrganisationType,
} from '../../__generated__/types';
import { useGetCurrentUserOrganisationInfoSuspenseQuery } from './__generated__/organisationInfo.generated';

type ContextType = {
	organisationInfo: OrganisationInfo | null;
	isAnyTeamAdmin: boolean;
	shouldEnablePostsScreening: boolean;
};

const [useOrganisationInfo, OrganisationInfoDataProvider] = createCtx<ContextType>();

const OrganisationInfoProvider = ({ children }: { children?: ReactNode }) => {
	const { i18n } = useTranslation();
	const { data } = useGetCurrentUserOrganisationInfoSuspenseQuery();

	const organisationInfo = data.currentUser.organisationInfo ?? null;

	const isAnyTeamAdmin =
		organisationInfo?.teams.some((team) => team.role === OrganisationTeamRole.Admin) ?? false;

	const shouldEnablePostsScreening =
		(!isAnyTeamAdmin && organisationInfo?.teams.some((team) => team.postsScreeningEnabled)) ??
		false;

	//TODO if all types will be supported just pass organisation type
	i18n.emit(
		'reloadInterpolations',
		organisationInfo?.type === OrganisationType.Education ? organisationInfo.type : 'default',
	);

	return (
		<OrganisationInfoDataProvider
			value={{ organisationInfo, isAnyTeamAdmin, shouldEnablePostsScreening }}
		>
			{children}
		</OrganisationInfoDataProvider>
	);
};

export { useOrganisationInfo, OrganisationInfoProvider };
